import { NgModule } from '@angular/core';
import { AvailabilityErrorComponent } from '@/common/availability-error/availability-error.component';
import { UpdateBannerComponent } from '@/common/update-banner/update-banner.component';

@NgModule({
	declarations: [AvailabilityErrorComponent, UpdateBannerComponent],
	exports: [AvailabilityErrorComponent, UpdateBannerComponent],
})
export class SharedModule {}
